import React from "react"
import {
  Box, Center, Heading, Text,
} from "@chakra-ui/react"
import { join } from "services/utilities"
import ActionButton from "../ActionButton"

const Modern = ({
  buttonClick,
  actionText,
  coverImageUrl,
  dateHeader,
  dateLine1,
  dateLine2,
  locationLine1,
  locationLine2,
  locationLine3,
  locationVenue,
  rsvpButtonColor,
  title,
}: {
  buttonClick: (() => void) | null
  actionText: string
  coverImageUrl: string
  dateHeader: string
  dateLine1: string
  dateLine2: string
  locationLine1: string
  locationLine2: string
  locationLine3: string
  locationVenue: string
  rsvpButtonColor: string
  title: string
}) => {
  const hasImage = !!coverImageUrl

  return (
    <Box
      pos="relative"
      bgImage={hasImage ? `url("${coverImageUrl}")` : undefined}
      bgColor={hasImage ? undefined : "gray.200"}
      bgPosition="center"
      bgSize="cover"
      h="50vh"
    >
      <Center h="50vh" pos="relative">
        <Box bgColor="black" opacity="0.5" h="100%" w="100%" />
        <Box color="white" textAlign="center" pos="absolute" px={6}>
          <Text fontSize="lg" fontWeight="semibold" my={1}>
            {join([dateHeader, dateLine1, dateLine2])}
          </Text>
          <Heading my={6} fontSize="5xl" fontWeight="semibold">
            {title}
          </Heading>
          <Text fontWeight="bold" fontSize="xl">
            {locationVenue}
          </Text>
          <Text fontSize="lg">
            {join([locationLine1, locationLine2, locationLine3])}
          </Text>
          {buttonClick && (
            <Box my={7} display={{ base: "none", lg: "block" }}>
              <ActionButton
                text={actionText}
                color={rsvpButtonColor}
                buttonClick={buttonClick}
              />
            </Box>
          )}
        </Box>
      </Center>
    </Box>
  )
}

export default Modern
